import $ from 'jquery';
import { throttle } from 'throttle-debounce';

import { $Elements, Breakpoints, Classes, Durations, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, mediaQuery, smoothScrollTo } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$Elements.PageWrapper.on(Events.click, '.menu-toggle, a[href="#menu-wrapper"], .menu-overlay', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.body.removeClass(Classes.menuOpen);
			enableBodyScroll();
		}
		else {
			$Elements.body.addClass(Classes.menuOpen);

			if($Elements.body.hasClass(Classes.winesMenuOpen)) {
				$Elements.body.removeClass(Classes.winesMenuOpen);
				$('.wines-menu-toggle').removeClass(Classes.active);
			}

			disableBodyScroll();
		}
	});

	$Elements.PageWrapper.on(Events.click, '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				smoothScrollTo(section);
			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}
	});

	$Elements.MenuWrapper.each(function() {

		const images = $(this).find('.menu-images');
		const columns = images.find('.image-column');
		const links = $(this).find('.menu-links');
		const items = links.find('.menu-item:not(.menu-item-has-children)');
		const active = links.find('.menu-item.' + Classes.active);

		if(active.length) {
			images.find('.image-column.' + active.attr('id')).addClass(Classes.active);
		}
		else {
			$(columns[0]).addClass(Classes.active);
		}

		items.on('mouseenter', throttle(Durations.default.ms, function() {

			setTimeout(() => {

				items.removeClass(Classes.active);
				this.classList.add(Classes.active);

				columns.removeClass(Classes.active);
				images.find('.image-column.' + $(this).attr('id')).addClass(Classes.active);
			}, 10);
		}));
	});

	// ---------- Menu Wine Range ----------

	const handleWinesMenuButton = function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.winesMenuOpen)) {
			$Elements.body.removeClass(Classes.winesMenuOpen);
			$('.wines-menu-toggle').removeClass(Classes.active);
			enableBodyScroll();
		}
		else {
			$Elements.body.addClass(Classes.winesMenuOpen);
			$('.wines-menu-toggle').addClass(Classes.active);

			if($Elements.body.hasClass(Classes.menuOpen)) {
				$Elements.body.removeClass(Classes.menuOpen);
			}

			disableBodyScroll();
		}
	}

	mediaQuery(Breakpoints.mobile, () => {

		$Elements.PageWrapper.off(Events.click, '.wines-menu-toggle', handleWinesMenuButton);

		if($Elements.body.hasClass(Classes.winesMenuOpen)) {
			$Elements.body.removeClass(Classes.winesMenuOpen);
			$('.wines-menu-toggle').removeClass(Classes.active);
			enableBodyScroll();
		}
	}, () => {
		$Elements.PageWrapper.on(Events.click, '.wines-menu-toggle', handleWinesMenuButton);
	});

	$('.wines-menu-wrapper .nav-link').on('mouseenter', throttle(Durations.default.ms, function() {

		setTimeout(() => {
			$(this).tab('show');
		}, 10);
	}));
});

$Elements.document.on(Events.page.loaded, () => {

	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}
});
